import { NAMED_CACHE_NAME } from "@/shared/utils/sw/sw.constants";
import { selectorDownloadProgresses } from "@/shared/store/sw/selectorDownloadProgresses";

export const selectorDownloadBooksProgresses = (state) => {
  return selectorDownloadProgresses(state)[NAMED_CACHE_NAME.BOOK_DATA];
};